export default "/_next/static/chunks/fonts/SourceSans3-Bold-latin-f237b8ad4f1b34627675169fd2c673e2.woff2";